import React from 'react';
import { LegendDoughnutChartProps } from './DoughnutChart.type';

const LegendDoughnutChart: React.FC<LegendDoughnutChartProps> = ({
  items,
  styleLegend,
  className,
}) => {
  return (
    <div className={`mt-4 ${styleLegend}`}>
      {items.map((item, index) => (
        <div
          key={index}
          className={`flex justify-between items-center mb-2 ${className}`}
        >
          <div className="flex items-center">
            <div className="flex justify-center items-center size-[30.2px] bg-[#3699FF14] rounded-[5.6px] mr-3">
              <div
                className={`size-4 rounded-[2.8px]`}
                style={{ backgroundColor: item.color }}
              />
            </div>
            <div>
              <p className="m-0 text-[11px] text-white">{item.label}</p>
              <p className="m-0 text-xs text-textColor">
                {item.value.toLocaleString()}
              </p>
            </div>
          </div>

          <p className="m-0 text-sm text-primary">
            {item.percentageOrSalesCount}
          </p>
        </div>
      ))}
    </div>
  );
};

export default LegendDoughnutChart;
